import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import MainLayout from '../components/layout/MainLayout'
import Home from '../pages/Home'
import Benefits from '../pages/Benefits'
import Research from '../pages/Research'
import Directory from '../pages/Directory'
import SubmitOrganisation from '../pages/SubmitOrganisation'
import About from '../pages/About'
import NotFound from '../pages/NotFound'

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SentryRoutes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="benefits" element={<Benefits />} />
          <Route path="research" element={<Research />} />
          <Route path="directory" element={<Directory />} />
          <Route path="submit" element={<SubmitOrganisation />} />
          <Route path="about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </SentryRoutes>
    </BrowserRouter>
  )
}
